import React from 'react';
import RenderPDFPreview from '../global/RenderPDFPreview';
import { DEFAULT_PDF_ZOOM } from '../global/constants';
import './Modal.css';
import axios from 'axios';
import { BASE_URL } from '../global/Server/endpoints';

class FilePreviewer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      attemptFailed: false,
      pdfData: null,
      loading: false,
    };
  }

  componentDidMount() {
    const { file } = this.props;
    if (file?.path && file?.type === 'application/pdf') {
      this.fetchPdfPreview(file.path);
    }
  }

  fetchPdfPreview = async (filePath) => {
    this.setState({ loading: true });
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${BASE_URL}/folder/previewPDF`,
        { path: filePath },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response?.data?.success && Array.isArray(response.data.pdfByte)) {
        const pdfData = new Uint8Array(response.data.pdfByte);
        this.setState({ pdfData, loading: false });
      } else {
        this.setState({ attemptFailed: true, loading: false });
      }
    } catch (error) {
      console.error('Error fetching PDF:', error);
      this.setState({ attemptFailed: true, loading: false });
    }
  };

  renderDownloadUI = (fileName, fileUrl) => {
    return (
      <div className="unsupported-file-container">
        <div className="unsupported-icon">
          <span role="img" aria-label="document icon">
            📄
          </span>
        </div>
        <h3 className="unsupported-title">Preview Not Supported</h3>
        <p className="unsupported-text">
          We can't display{' '}
          <span className="file-highlight">{fileName || 'this file'}</span>{' '}
          directly in your browser. Only images and PDFs can be viewed here.
        </p>
      </div>
    );
  };

  render() {
    const { file, handlePdfLoadSuccess, handlePdfLoadError } = this.props;
    const { pdfData, attemptFailed, loading } = this.state;

    if (!file) return null;

    const isImage = file.type?.startsWith('image');
    const isPDF = file.type === 'application/pdf';
    const isUnsupported = !isImage && !isPDF;

    return (
      <div className="preview-wrapper">
        {/* 1. Loading State */}
        {loading && (
          <div className="preview-loader">
            <div className="spinner"></div>
            <p>Loading preview...</p>
          </div>
        )}

        {/* 2. Image Preview */}
        {isImage && !attemptFailed && (
          <div className="image-preview-container">
            <img
              alt="preview"
              src={file.url}
              className="image-preview"
              onLoad={() => this.setState({ loading: false })}
              style={{ display: loading ? 'none' : 'block' }}
              onError={() =>
                this.setState({ attemptFailed: true, loading: false })
              }
            />
          </div>
        )}

        {/* 3. PDF Preview */}
        {isPDF && pdfData && !attemptFailed && (
          <RenderPDFPreview
            data={{ pdfData }}
            creating={true}
            handlePdfLoadSuccess={() => {
              this.setState({ loading: false });
              if (handlePdfLoadSuccess) handlePdfLoadSuccess();
            }}
            handlePdfLoadError={() => {
              this.setState({ attemptFailed: true, loading: false });
              if (handlePdfLoadError) handlePdfLoadError();
            }}
            scale={DEFAULT_PDF_ZOOM}
          />
        )}

        {/* 4. Unsupported or Failed State */}
        {(isUnsupported || attemptFailed) &&
          !loading &&
          this.renderDownloadUI(file.name, file.url)}
      </div>
    );
  }
}

export default FilePreviewer;
